import BaseModal from "components/modal/BaseModal";
import ButtonGroup from "components/button/ButtonGroup";
import ErrorLayout from "components/error/ErrorLayout";
import useModal from "hooks/components/useModal";
import usePageNavigate from "hooks/common/usePageNavigate";
import React, { useEffect } from "react";
import { GrRotateLeft } from "react-icons/gr";
import { MdOutlineError } from "react-icons/md";
import ReactDOM from "react-dom";

const FrontErrorContent = ({ children }) => {
  const { onNavClick } = usePageNavigate();
  const { visibleModal, openModal, closeModal } = useModal();
  useEffect(() => {
    openModal("frontendError", "프론트 오류");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {children}
      {ReactDOM.createPortal(
        <BaseModal visible={visibleModal.isopen}>
          <ErrorLayout
            icon={<MdOutlineError />}
            // title="일시적인 오류가 발생했습니다."
            title={
              <>
                서비스 이용에 불편을 드려 죄송합니다.
                <br />
                일시적인 오류가 발생했습니다.
              </>
            }
            desc={[
              // "문제를 해결하기 위해 열심히 노력하고 있습니다.",
              "잠시 후 다시 시도해주세요.",
            ]}
            button={
              <ButtonGroup
                className="error_content_group"
                button={[
                  {
                    text: "메인으로",
                    variant: "dark-outline",
                    size: "big",
                    onClick: () => {
                      closeModal();
                      onNavClick("/");
                    },
                    gtm: {
                      url: "/",
                      id: "front-error-modal-main-btn",
                    },
                  },
                  {
                    beforeIcon: <GrRotateLeft />,
                    text: "다시 불러오기",
                    variant: "primary",
                    size: "big",
                    className: "error_reload",
                    onClick: () => {
                      closeModal();
                      window.location.reload();
                    },
                    gtm: {
                      url: window.location,
                      id: "front-error-modal-reload-btn",
                    },
                  },
                ]}
              />
            }
          />
        </BaseModal>,
        document.body
      )}
    </>
  );
};

export default FrontErrorContent;
